import Selector from './Selector.vue';
export default Selector;
